import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=84057e14&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user/userCenter.css?vue&type=style&index=0&id=84057e14&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84057e14",
  null
  
)

export default component.exports